import config from '@/language/pt/components/config';
import filters from '@/language/pt/components/filters';
import models from '@/language/pt/components/cards/models';
import filter from '@/language/pt/components/filter';
import post from '@/language/pt/components/post';
import PublishSwitch from '@/language/pt/components/PublishSwitch';
import Impress from '@/language/pt/components/Impress';
import OperatorsLogs from '@/language/pt/components/OperatorsLogs';
import CopyToClipboard from '@/language/pt/components/CopyToClipboard';
import AddCardModal from '@/language/pt/components/AddCardModal';
import HiddenCardsModal from '@/language/pt/components/HiddenCardsModal';
import RemoveCardModal from '@/language/pt/components/RemoveCardModal';
import CardModal from '@/language/pt/components/CardModal';
import DashCardsContainer from '@/language/pt/components/DashCardsContainer';
import GlobalFilter from '@/language/pt/components/GlobalFilter';
import GlobalFilterModal from '@/language/pt/components/GlobalFilterModal';
import GlobalFilterSummary from '@/language/pt/components/GlobalFilterSummary';
import GlobalFilterMenu from '@/language/pt/components/GlobalFilterMenu';
import CallsIncomingAttended from '@/language/pt/components/CallsIncomingAttended';
import Badge from '@/language/pt/components/Badge';
import DashFilterBar from '@/language/pt/components/DashFilterBar';
import AddDescriptionModal from '@/language/pt/components/AddDescriptionModal';
import AnnotationTextCard from '@/language/pt/components/AnnotationTextCard';
import MenuBar from '@/language/pt/components/MenuBar';
import HelpButton from '@/language/pt/components/HelpButton';
import PublicAccessModal from '@/language/pt/components/PublicAccessModal';
import Onboarding from '@/language/pt/components/Onboarding';
import EnvironmentInfo from '@/language/pt/components/EnvironmentInfo';
import AnnotationImageCard from '@/language/pt/components/AnnotationImageCard';
import FileImporter from '@/language/pt/components/FileImporter';
import ImportHistory from '@/language/pt/components/ImportHistory';
import TextFilter from '@/language/pt/components/TextFilter';
import CustomerServiceRatings from '@/language/pt/components/CustomerServiceRatings';
import OptionsButton from '@/language/pt/components/OptionsButton';
import StatusTable from '@/language/pt/components/StatusTable';
import UserMenu from '@/language/pt/components/UserMenu';
import ComponentBuildModal from '@/language/pt/components/ComponentBuildModal';
import BlipMessageVolumeInPeriod from '@/language/pt/components/BlipMessageVolumeInPeriod';
import BlipEngagedAndNonEngagedContacts from '@/language/pt/components/BlipEngagedAndNonEngagedContacts';
import BlipActiveMessagesByChannel from '@/language/pt/components/BlipActiveMessagesByChannel';
import ConsolidatedCSATPieChart from '@/language/pt/components/ConsolidatedCSATPieChart';
import BaseChannelPieChartOwnedEarned from '@/language/pt/components/BaseChannelPieChartOwnedEarned';
import CustomErrorMessage from '@/language/pt/components/CustomErrorMessage';
import GPTSuggestions from '@/language/pt/components/GPTSuggestions';
import SentmentByTagTreeview from '@/language/pt/components/SentmentByTagTreeview';
import LoversTable from '@/language/pt/components/LoversTable';
import BlipActiveCampaignComponents from '@/language/pt/components/BlipActiveCampaignComponents';
import BlipOpenTicketsTable from '@/language/pt/components/BlipOpenTicketsTable';
import BlipMonitoringAttendantsTable from '@/language/pt/components/BlipMonitoringAttendantsTable';
import BlipReportsTicketsInTime from '@/language/pt/components/BlipReportsTicketsInTime';
import BlipMonitoringTeamsTable from '@/language/pt/components/BlipMonitoringTeamsTable';
import BlipDeskComponents from '@/language/pt/components/BlipDeskComponents';
import BlipReportsTable from '@/language/pt/components/BlipReportsTable';
import InterestLovers from '@/language/pt/components/InterestLovers';
import CommentSheetImporter from '@/language/pt/components/CommentSheetImporter';
import BlipTagsMetricsTable from '@/language/pt/components/BlipTagsMetricsTable';
import BlipWaitingTicketsTable from '@/language/pt/components/BlipWaitingTicketsTable';
import AverageSACTimePieChart from '@/language/pt/components/AverageSACTimePieChart';
import PerformanceByTimeMatrix from '@/language/pt/components/PerformanceByTimeMatrix';
import PerformanceByChannel from '@/language/pt/components/PerformanceByChannel';
import ImportPostTags from '@/language/pt/components/ImportPostTags';
import AutoReload from '@/language/pt/components/AutoReload';
import ChooseCardMenu from '@/language/pt/components/ChooseCardMenu';
import DateFilter from '@/language/pt/components/DateFilter';
import ResizeModal from '@/language/pt/components/ResizeModal';
import DashTopBar from '@/language/pt/components/DashTopBar';
import TopPosts from '@/language/pt/components/TopPosts';
import PropTopPosts from '@/language/pt/components/PropTopPosts';
import PropTopCommentsPosts from '@/language/pt/components/PropTopCommentsPosts';
import TimelineProprietaryPosts from '@/language/pt/components/TimelineProprietaryPosts';
import EngagementMatrix from '@/language/pt/components/EngagementMatrix';
import SentimentByTagTreeviewFilter from '@/language/pt/components/SentimentByTagTreeviewFilter';
import StockVsSentimentLineChart from '@/language/pt/components/StockVsSentimentLineChart';
import StockVsSocialLineChart from '@/language/pt/components/StockVsSocialLineChart';
import SacReportCallsQuantity from '@/language/pt/components/SacReportCallsQuantity';
import GranularityDropDown from '@/language/pt/components/GranularityDropDown';
import VariationOfFanBaseChart from '@/language/pt/components/VariationOfFanBaseChart';
import GoogleMyBusinessRatingsByStars from '@/language/pt/components/GoogleMyBusinessRatingsByStars';

export default {
  config,
  filters,
  models,
  filter,
  post,
  PublishSwitch,
  CardModal,
  DashCardsContainer,
  CopyToClipboard,
  AddCardModal,
  HiddenCardsModal,
  RemoveCardModal,
  Impress,
  GlobalFilter,
  GlobalFilterModal,
  GlobalFilterSummary,
  OperatorsLogs,
  Badge,
  DashFilterBar,
  AddDescriptionModal,
  AnnotationTextCard,
  MenuBar,
  HelpButton,
  PublicAccessModal,
  Onboarding,
  EnvironmentInfo,
  AnnotationImageCard,
  FileImporter,
  ImportHistory,
  TextFilter,
  CustomerServiceRatings,
  OptionsButton,
  StatusTable,
  UserMenu,
  ComponentBuildModal,
  BlipMessageVolumeInPeriod,
  BlipEngagedAndNonEngagedContacts,
  BlipActiveMessagesByChannel,
  ConsolidatedCSATPieChart,
  BaseChannelPieChartOwnedEarned,
  CustomErrorMessage,
  GPTSuggestions,
  SentmentByTagTreeview,
  LoversTable,
  BlipActiveCampaignComponents,
  BlipReportsTicketsInTime,
  BlipDeskComponents,
  BlipReportsTable,
  InterestLovers,
  CommentSheetImporter,
  BlipOpenTicketsTable,
  BlipMonitoringAttendantsTable,
  BlipMonitoringTeamsTable,
  BlipTagsMetricsTable,
  BlipWaitingTicketsTable,
  AverageSACTimePieChart,
  PerformanceByTimeMatrix,
  PerformanceByChannel,
  ImportPostTags,
  GlobalFilterMenu,
  CallsIncomingAttended,
  AutoReload,
  ChooseCardMenu,
  DateFilter,
  ResizeModal,
  DashTopBar,
  TopPosts,
  PropTopPosts,
  PropTopCommentsPosts,
  TimelineProprietaryPosts,
  EngagementMatrix,
  SentimentByTagTreeviewFilter,
  StockVsSentimentLineChart,
  StockVsSocialLineChart,
  SacReportCallsQuantity,
  GranularityDropDown,
  VariationOfFanBaseChart,
  GoogleMyBusinessRatingsByStars,
};
